import { CriteriaCategory, CriteriaFramework } from './CriteriaFramework';

// Not mirrored in criteria_framework.rb (the backend keeps no definitions);
// keys must match FRAMEWORK_CATEGORIES in ./CriteriaFramework.
export const FRAMEWORK_DEFINITIONS: Record<
  CriteriaFramework,
  Partial<Record<CriteriaCategory, string>>
> = {
  picos: {
    population:
      'Group(s) of individuals, organizations, or entities that are the primary focus of the study',
    intervention_exposure:
      'Treatments, procedures, assessments, programmes, policy or other change being evaluated in the study',
    comparator_context:
      'Alternative(s) or reference point against which the intervention is being evaluated',
    outcome:
      'Specific results or effects that are measured or assessed as a result of the intervention',
    study_characteristics: 'Research design used in the study',
    other:
      "Any additional information that affects a study's eligibility for your review or is helpful to consider during screening",
  },
  pecos: {
    population:
      'Group(s) of individuals, organizations, or entities that are the primary focus of the study',
    intervention_exposure:
      'Condition, lifestyle factor, risk factor, event, or experience the population has been exposed to',
    comparator_context:
      'Group or condition without the exposure, used as a reference to assess effects',
    outcome: 'Result or effect associated with the exposure being measured',
    study_characteristics: 'Research design used in the study',
    other:
      "Any additional information that affects a study's eligibility for your review or is helpful to consider during screening",
  },
  spider: {
    population:
      'Group(s) of participants or units from which data is collected',
    intervention_exposure:
      'Experience, behaviour, process, or issue being explored in the study',
    design: 'Approach used to collect and analyze data',
    outcome:
      'Method, tool, or measure used to assess or capture the phenomenon',
    study_characteristics: 'Research methodology used in the study',
    other:
      "Any additional information that affects a study's eligibility for your review or is helpful to consider during screening",
  },
  pico: {
    population:
      'Group(s) of individuals, organizations, or entities that are the primary focus of the study',
    intervention_exposure:
      'Experience, behaviour, process, or issue being explored in the study',
    context_setting:
      'Setting, environment, or circumstances in which the phenomenon occurs',
    other:
      "Any additional information that affects a study's eligibility for your review or is helpful to consider during screening",
  },
  pcc: {
    population:
      'Group(s) of individuals, organizations, or entities that are the primary focus of the study',
    intervention_exposure:
      'Key idea or subject matter, such as an intervention, exposure, experience, or outcome, being mapped or examined',
    context_setting:
      'Setting, geographic location, or circumstances in which the concept is being examined',
    other:
      "Any additional information that affects a study's eligibility for your review or is helpful to consider during screening",
  },
  spice: {
    context_setting:
      'Environment, location, or context in which the study is conducted or the intervention is delivered',
    population:
      'Viewpoint, stakeholder group, or subject whose experience or perception is being examined',
    intervention_exposure:
      'Treatments, assessments, policies or strategies being evaluated in the study',
    comparator_context:
      'Alternative(s) or reference point against which the intervention is being evaluated',
    outcome:
      'Outcome or measure used to assess the impact or effectiveness of the intervention',
    other:
      "Any additional information that affects a study's eligibility for your review or is helpful to consider during screening",
  },
  other: {
    other:
      "Any information that affects a study's eligibility for your review or is helpful to consider during screening",
  },
};
